import { render, staticRenderFns } from "./DialogManageTable.vue?vue&type=template&id=54ebe8b0&scoped=true"
import script from "./DialogManageTable.vue?vue&type=script&lang=js"
export * from "./DialogManageTable.vue?vue&type=script&lang=js"
import style0 from "./DialogManageTable.vue?vue&type=style&index=0&id=54ebe8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ebe8b0",
  null
  
)

export default component.exports